module.exports = __webpack_public_path__ + "img/related-img-btn.9c453146.svg";